import Stack from '@mui/material/Stack';
import { memo } from 'react';
//
import { useAuthContext } from 'src/auth/hooks';
import { USER_TYPE } from 'src/types/ApiConstant';
import { navMiniConfig } from '../config';
import { NavConfigProps, NavListProps, NavSectionProps } from '../types';
import NavList from './nav-list';

// ----------------------------------------------------------------------

function NavSectionMini({ data, config, sx, ...other }: NavSectionProps) {
  const { user } = useAuthContext();
  return (
    <Stack sx={sx} {...other}>
      {data.map((group, index) => {
        const condition =
          (!group.forReader && USER_TYPE.SYSTEM_USER === user?.type) ||
          (group.forReader && USER_TYPE.READER === user?.type);
        return condition ? (
          <Group
            key={group.subheader || index}
            items={group.items}
            config={navMiniConfig(config)}
          />
        ) : null;
      })}
    </Stack>
  );
}

export default memo(NavSectionMini);

// ----------------------------------------------------------------------

type GroupProps = {
  items: NavListProps[];
  config: NavConfigProps;
};

function Group({ items, config }: GroupProps) {
  return (
    <>
      {items.map((list) => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={1}
          hasChild={!!list.children}
          config={config}
        />
      ))}
    </>
  );
}
